import React from 'react';

function Mission() {
    return (
        <div id="about" className="py-16 md:py-24">
            <div className="max-w-4xl mx-auto text-center">
                <h2 className="text-3xl md:text-5xl font-bold text-white mb-8">
                    Born from Necessity, Built for Excellence
                </h2>
                <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed">
                    <p>
                        Fuse Robotics was founded when two expert engineers grew frustrated with the 
                        challenges of securing limited-release collectibles. Rather than accept the 
                        status quo, we built the solution.
                    </p>
                    <p>
                        Through cutting-edge automation software and relentless innovation, we've helped 
                        thousands of members secure their favorite collectibles at retail prices. Our commitment 
                        to technical excellence and customer success drives everything we do.
                    </p>
                    <p className="text-fuse-orange font-semibold">
                        Built by experts, tuned to perfection.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Mission;

